<template>
  <b-card class="shipping-item" :class="sale.shipping_id !== null || sale.fraud_risk_detected ? 'text-muted' : ''">
    <span style="position: absolute; top: 0; left: 0; padding: 0 10px" class="bg-danger text-light" v-if="sale.fraud_risk_detected"><small><translate>Fraud Risk Detected by MercadoLibre</translate></small></span>
    <b-row>
      <b-col cols="6" order="1">
        <strong v-if="sale.shipping_id !== null" class="text-success"><translate>Shipping already created with ID</translate> <a :href="'/shippings/' + sale.shipping_id" target="_blank">#{{sale.shipping_id | uuid}}</a> :)</strong>
        <strong v-else :class="sale.status !== 'ready_to_ship' || sale.fraud_risk_detected ? 'text-danger' : 'text-success'">{{filterStates[sale.status]}}</strong>
      </b-col>
      <b-col order="1" class="text-right">
        {{moment.utc(sale.date_closed).local().format('L LT')}}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <hr>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="6" lg="2" class="mb-3 mb-lg-0" order="1">
        <div>
          <h6 v-translate>Order ID</h6>
          <strong class="shipping-id">{{sale.external_order_id}}</strong><br>
        </div>
      </b-col>
      <b-col cols="12" md="6" lg="2" class="mb-3 mb-lg-0" order="4" order-lg="3">
        <h6 v-translate>Buyer</h6>
        <span>
          {{sale.to_contact}} ({{sale.nickname}})
        </span>
      </b-col>
      <b-col cols="12" md="6" lg="3" class="mb-3 mb-lg-0" order="4" order-lg="3">
        <h6 v-translate>Destination</h6>
          <span v-if="sale.address_to">
            {{sale.address_to.formatted_address}} {{this.order.to_extra ? '(' + this.order.to_extra + ')' : ''}}
          </span>
      </b-col>
      <b-col cols="12" md="6" lg="5" class="mb-3 mb-lg-0" order="4" order-lg="3" v-if="sale.shipping_id === null">
        <h6><translate>Instructions on destination</translate></h6>
        <span v-if="this.order.to_meta">
          <span v-if="!editing" @click="editing = true">{{this.order.to_meta}}</span>
        </span>
        <span v-else-if="!editing" @click="editing = true" v-translate>
          No instructions
        </span>
        <div class="form-group" v-if="editing">
          <div class="input-group">
            <b-form-textarea id="to_meta" name="to_meta" v-model="order.to_meta" :rows="3" :max-rows="6" @input="countdown('to_meta', 255)" /><br>
          </div>
          <small class="form-text text-muted"><span v-translate="{courierI18n: this.courierI18n}">Do you have any special instruction for our %{courierI18n} on delivery?</span><br>
          <translate>i.e.</translate> <em v-translate>The door bell is not working</em></small>
          <b-button variant="primary" style="padding: 0.1rem 1rem;" @click="editing = false" v-translate>Done</b-button>
        </div>
      </b-col>
    </b-row>
    <b-row v-for="(item, index) in sale.shipping_items" :key="index">
      <b-col cols="12">
        <hr>
      </b-col>
      <b-col cols="10" md="6" lg="4">
        - {{item.description}}
      </b-col>
      <b-col>
        {{item.quantity}} u.
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: 'MercadolibreListItem',
  data() {
    return {
      filterStates: {
        delivered: this.$gettext('Delivered'),
        shipped: this.$gettext('In transit'),
        to_be_agreed: this.$gettext('To be agreed'),
        ready_to_ship: this.$gettext('Ready to ship'),
        cancelled: this.$gettext('Cancelled'),
        not_delivered: this.$gettext('Not delivered'),
        pending: this.$gettext('Pending'),
        handling: this.$gettext('Handling'),
        not_verified: this.$gettext('Not verified'),
        closed: this.$gettext('Closed'),
        error: this.$gettext('Error'),
        active: this.$gettext('Active'),
        not_specified: this.$gettext('Not specified'),
        stale_ready_to_ship: this.$gettext('Ready to ship (staled)'),
        stale_shipped: this.$gettext('Shipped (staled)')
      },
      order: {},
      limits: {},
      invalid: {},
      editing: false
    }
  },
  props: {
    sale: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.order = this.sale
    this.fixedToMeta()
  },
  methods: {
    fixedToMeta() {
      if (this.sale.to_extra) {
        const fixedToMetaStr = ((' ' + this.sale.to_extra).slice(1)).split(': ')

        this.order.to_meta = fixedToMetaStr[1] ? fixedToMetaStr[1].replace(/ Entre/g, '') + '. ' + (typeof fixedToMetaStr[2] !== 'undefined' ? 'Entre: ' + fixedToMetaStr[2] : '') : ''
        this.order.to_extra = fixedToMetaStr[0] ? fixedToMetaStr[0].replace(/ Referencia| Entre/g, '') : ''
      }
    },
    countdown(value, limit) {
      this.limits[value] = this.order[value] ? limit - this.order[value].length : null
      this.invalid[value] = this.order[value] ? this.order[value].length <= limit : null
    }
  }
}
</script>
